import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../apiClient";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    if (window.location.pathname === "/login") {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const res = await api.get("/users/me");

      if (res.data?.status) {
        setUser({
          _id: res.data.user._id,
          nome: res.data.user.name,
          cognome: res.data.user.surname,
          ruolo: res.data.user.role,
          email: res.data.user.email
        });
      } else {
        setUser(null);
      }
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, loading, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUser deve essere usato dentro UserProvider");
  }

  return context;
}